module.exports = __webpack_public_path__ + "static/media/Topic_Icons2_QuestionsBox.9ba8484b.png";